module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/contacts_group-3c0125140d8b6125212e4c5c3033ace6.svg";